import { useSet } from 'react-use';

import useUsers from '@/components/UsersSearch/hooks/useUsers';
import { UserFragment } from '@/graphql/fragments/generated/User';
import { UserTypeEnum } from '@/types/schema';

const useUsersList = ({
  selectedUserIds,
  debounceSearchText,
}: {
  selectedUserIds: string[];
  debounceSearchText: string;
}) => {
  const {
    isFetching: fetchingUsers,
    data: users,
    fetchMore: fetchMoreUsers,
  } = useUsers({
    searchText: debounceSearchText,
    userTypes: [UserTypeEnum.Learner],
  });

  const [selectedUserIdsSet, { toggle: toggleSelectedUserIds }] = useSet(new Set(selectedUserIds));

  return {
    selectedUserIdsSet,
    toggleSelectedUserIds,
    fetchingUsers,
    fetchMoreUsers,
    users: users as UserFragment[],
  };
};

export default useUsersList;
